export const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || 
    	'http://localhost:8080/api';



// WEBPACK FOOTER //
// ./src/config.js